import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter, Input,
  Output,
  ViewChild
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { fromEvent, Observable } from 'rxjs/index';
import { debounceTime, distinctUntilChanged, filter, map, tap } from 'rxjs/operators';
import { UserAction } from './state/user.action';
import { UserSelectors } from './state/user.selectors';
import { User } from '../core/model/user.model';

@Component({
    selector: 'user-search',
    templateUrl: './user-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchComponent implements AfterViewInit {

    @Input() disable?: boolean;
    @Output() isTyping?: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('userSearchInput') userSearchInput: ElementRef;
    foundUsers$: Observable<Array<any>>;
    selectedUser = {userId: undefined, name: ''};
    selectedUser$:  Observable<User>;

    constructor(private store: Store<any>,
                private userSelectors: UserSelectors
    ) {
        this.foundUsers$ = this.userSelectors.selectSearchUsers()
            .pipe(
                filter(users => users !== undefined)
            );

        this.selectedUser$ = this.userSelectors.selectSelectedUser()
            .pipe(
                filter(user => user !== undefined),
                tap(user => this.selectedUser = {userId: user.userId, name: user.userName})
            );
    }

    ngAfterViewInit(): void {
        this.userSearchInput.nativeElement.focus();
        this.subscribeToKeyDownEvents();
    }

    subscribeToKeyDownEvents(): void {
        // typeaheadWaitMs does NOT debounce input but delays when found list pops up
        // So we have to roll our own
        fromEvent(this.userSearchInput.nativeElement, 'keyup')
            .pipe(
                map(($event: any) => $event.target.value),
                filter((searchPattern: string) => searchPattern.length > 2),
                debounceTime(500),
                distinctUntilChanged())
            .subscribe((searchPattern: string) => {
              if(this.isTyping !== undefined){
                this.isTyping.emit(true);
              }

              if(this.disable){
                return;
              }

              this.store.dispatch(UserAction.searchUser({searchPattern}));
            });

        // NOTE: no need to unsubscribe to fromEvent as this only adds a reference in the DOM
    }

    onSelect($event: TypeaheadMatch): void {
        this.selectedUser = $event.item;
        this.store.dispatch(UserAction.getSelectedUserById({userId: this.selectedUser.userId}));
    }
}
